__turbopack_context__.v({
  "accordionSlideOverwrite": "comboBox-module-scss-module___dwYHq__accordionSlideOverwrite",
  "checkIcon": "comboBox-module-scss-module___dwYHq__checkIcon",
  "checkIcon--hidden": "comboBox-module-scss-module___dwYHq__checkIcon--hidden",
  "fadeIn": "comboBox-module-scss-module___dwYHq__fadeIn",
  "fadeOut": "comboBox-module-scss-module___dwYHq__fadeOut",
  "popover": "comboBox-module-scss-module___dwYHq__popover",
  "scaleIn": "comboBox-module-scss-module___dwYHq__scaleIn",
  "scaleOut": "comboBox-module-scss-module___dwYHq__scaleOut",
  "trigger": "comboBox-module-scss-module___dwYHq__trigger",
  "zoomIn": "comboBox-module-scss-module___dwYHq__zoomIn",
  "zoomOut": "comboBox-module-scss-module___dwYHq__zoomOut",
});
